module.exports = __webpack_public_path__ + "img/3.11fc4668.png";